import React, { createContext, useContext } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Api } from "../utils/api";
import { useQuery } from "react-query";

const api = new Api();

const Context = createContext();

const getUsersList = async () => {
  const { data: users } = await api.get(`/users?all=true`);
  return users;
};

export const UsersListProvider = ({ children }) => {
  const { data, isLoading } = useQuery(["users"], () => getUsersList());

  if (isLoading) {
    return <CircularProgress color="primary" />;
  }

  return (
    <Context.Provider value={{ usersList: data }}>{children}</Context.Provider>
  );
};

export const useUsersList = () => {
  const { usersList } = useContext(Context) || {};
  return usersList || [];
};
